import Header from '@/components/Header';
import MenuSection from '@/components/MenuSection';
import Footer from '@/components/Footer';
import Cart from '@/components/Cart';
import { useCart } from '@/context/CartContext';
import PageSEO from '@/components/PageSEO';

const MenuPage = () => {
  const { ordersEnabled } = useCart();

  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Menù – Pizzeria La Torre, Carmagnola (TO)"
        description="Scopri il menù della Pizzeria La Torre: pizze classiche, specialità e focacce. Disponibili anche senza glutine con certificazione AIC."
      />
      <Header />
      <main className="pt-20">
        <MenuSection />
      </main>
      <Footer />
      {ordersEnabled && <Cart />}
    </div>
  );
};

export default MenuPage;
